import { Base } from '@studiometa/js-toolkit';

/**
 *
 */
export default class Voucher extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Voucher',
    refs: ['input', 'reset'],
    emits: ['submit'],
  };

  /**
   * Reset input and refresh
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onResetClick({ event }) {
    event.preventDefault();
    this.$refs.input.value = '';
    this.$emit('submit');
  }
}
